import { PostRequestOptions, PostSource, Sort } from './PanelTemplatesTheme/PanelTemplatesTheme';
import { DefaultPosition } from './PanelTemplatesTheme/constants';
import { Panel } from 'models/Panel/Panel';
import { postCompositionConfigCollage } from 'components/Panel/PanelEditorSidebar/PanelDesign/PanelDesignOptions';
import { PostsWidgetOptions } from '../../widgets/PostsWidget/options';

export var TemplateCollage: Panel = {
    id: 'collage',
    name: 'Collage',
    description: '',
    tags: ['Content', 'Posts', 'Collage', 'landscape', 'portrait'],
    widget: {
        id: '1',
        position: {
            width: '1920px',
            height: '1080px',
            top: '0',
            left: '0',
        },
        classes: 'template_collage',
        children: [
            {
                type: 'postsCollage',
                id: '1',
                name: 'collage',
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                // Note: All global variables like reportingEngine, report, and filters
                                // are injected via PostRequest.getRequests()
                                id: new PostSource({
                                    pageSize: 60,
                                    sorts: [
                                        new Sort({
                                            order: 'DESC',
                                            heading: {
                                                MONITORING_DASHBOARD: 'REACH_COUNT',
                                                LISTENING: 'REACH_COUNT',
                                                INBOUND_MESSAGE: 'INBOUND_COUNT',
                                                PLATFORM: 'TOTAL_ENGAGEMENT',
                                                BENCHMARKING: 'TOTAL_ENGAGEMENT',
                                                CAMPAIGN: 'OUTBOUND_STATUS',
                                                RDB_FIREHOSE: 'SN_CREATED_TIME',
                                                STORY_MESSAGE: 'IMPACT',
                                            },
                                        }),
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        key: 'last_7_days',
                                    },
                                }) as any,
                                options: new PostRequestOptions(
                                    {
                                        MONITORING_DASHBOARD: {
                                            ignoreTimePeriod: true,
                                        },
                                    },
                                    {
                                        count: 200,
                                        imagePreload: true,
                                        removeDuplicates: true,
                                        includeFaceDetection: false,
                                        shufflePosts: false,
                                        removeSensitivePosts: true,
                                        includeQuoteTweets: false,
                                    }
                                ) as any,
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: { filter: "post.type == 'text'" },
                                    image: { filter: "post.type == 'image'" },
                                    any: { filter: 'post.type' },
                                },
                                panels: [
                                    { total: 10, buckets: ['text', 2, 'image', 8, 'any', -1] },
                                ],
                            },
                        },
                    },
                ],
                useGlobalTimePeriod: true,
                position: DefaultPosition,
                options: Object.assign(
                    {
                        player: {
                            playing: true,
                            duration: 6,
                        },
                        postTemplate: 'collage',
                        postTransition: 'scale',
                        userGroupEffect: 'bottom',
                        theme: 'primary',
                        showSentiment: true,
                        smartSize: {
                            enabled: true,
                            mode: 'responsive',
                            size: 'xl',
                        },
                        portrait: {
                            widgetOrientation: 'portrait',
                        },
                        imageFaceDetection: false,
                        postVersion: 2,
                    } as PostsWidgetOptions,
                    postCompositionConfigCollage.a
                ),
            },
        ],
        theme: {
            ext: {
                padding: 20,
            },
        },
    },
};
